import React from 'react';

interface SeoPreviewProps {
  title: string;
  description: string;
  slug: string;
  siteUrl?: string;
}

const SeoPreview: React.FC<SeoPreviewProps> = ({
  title,
  description,
  slug,
  siteUrl = 'https://travelbaba786.com',
}) => {
  const displayTitle = title.trim() || 'Your meta title will appear here';
  const displayDescription =
    description.trim() || 'Your meta description will appear here in search results.';
  const displayUrl = `${siteUrl.replace(/\/$/, '')}/blog/${slug.trim() || 'your-article-slug'}`;

  return (
    <div className="rounded-xl border border-gray-200 dark:border-gray-600 bg-gray-50 dark:bg-slate-900/50 p-4">
      <p className="text-xs font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400 mb-3">
        Google search preview
      </p>
      <div className="space-y-1">
        <p className="text-sm text-gray-600 dark:text-gray-400 truncate">{displayUrl}</p>
        <p className="text-xl text-blue-700 dark:text-blue-400 font-medium leading-snug line-clamp-2">
          {displayTitle}
        </p>
        <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed line-clamp-2">
          {displayDescription}
        </p>
      </div>
      <p className="text-xs text-gray-400 mt-3">
        Title: {title.length}/70 · Description: {description.length}/160
      </p>
    </div>
  );
};

export default SeoPreview;
